import { createTripArrayFieldMachine } from './createTripArrayFieldMachine';

export const passengerMobilityMachine =
  createTripArrayFieldMachine('passengerMobility');
